import * as React from "react";
import { Alert } from "antd";

const DateIsInFutureNotification = () => {
  return <Alert message="Kontrolldatum liegt in der Zukunft" type="warning" />  
};

export default DateIsInFutureNotification;
